// firebase.js or firebaseConfig.js
// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";

// console.log("process.env.apiKey", process.env.REACT_APP_FIREBASE_KEY);

// var firebaseConfig = {
//   apiKey: process.env.REACT_APP_FIREBASE_KEY || "AIzaSyCol5NeXLh2e2qonPFGZ6G298C3TdOCUAo",
//   authDomain: "roundpier-clubs.firebaseapp.com",
//   projectId: "roundpier-clubs",
//   // storageBucket: "roundpier-clubs.appspot.com",
//   storageBucket: "roundpier-clubs.firebasestorage.app",
//   messagingSenderId: "933953566858",
//   appId: "1:933953566858:web:33cd66eefcdc247b921573",
//   measurementId: "G-4BVVWL9MEW"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);


// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCol5NeXLh2e2qonPFGZ6G298C3TdOCUAo",
  authDomain: "roundpier-clubs.firebaseapp.com",
  projectId: "roundpier-clubs",
  storageBucket: "roundpier-clubs.firebasestorage.app",
  messagingSenderId: "933953566858",
  appId: "1:933953566858:web:33cd66eefcdc247b921573",
  measurementId: "G-4BVVWL9MEW"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const analytics = getAnalytics(app);

// // Initialize Firestore
// const db = getFirestore(app);

// export { db };

const db = getFirestore(app);
const storage = getStorage(app);

export { app, db, storage };
